import styled from 'styled-components'

export const CatalogItemImageStyled = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  mix-blend-mode: multiply;
  pointer-events: none;
`
